<template>
  <div v-if="hasRecaptcha" class="NoticeRecaptcha">
    <i18n path="recaptcha" tag="div">
      <template #policy>
        <a href="https://policies.google.com/privacy" rel="noreferrer" target="_blank">
          {{ $t('policy') }}
        </a>
      </template>
      <template #terms>
        <a href="https://policies.google.com/terms" rel="noreferrer" target="_blank">
          {{ $t('terms') }}
        </a>
      </template>
    </i18n>
  </div>
</template>

<script>
import { getters } from '../utils'

export default {
  computed: getters('hasRecaptcha'),
}
</script>

<style lang="scss">
.NoticeRecaptcha {
  font-size: $h8;
  margin: 1rem 0;
}
</style>

<i18n>
{
  "en": {
    "policy": "Privacy Policy",
    "recaptcha": "This site is protected by reCAPTCHA and the Google {policy} and {terms} apply.",
    "terms": "Terms of Service"
  }
}
</i18n>
